import * as React from "react";

import ActionsModifier from "@v1/components/editor/page/element-editor/components/modifiers/ActionsModifier";
import AnimationsModifier from "@v1/components/editor/page/element-editor/components/modifiers/AnimationsModifier";

const InteractionsTab: React.FC = () => {
  return (
    <div className="relative flex flex-col gap-4">
      <ActionsModifier />
      <AnimationsModifier />
    </div>
  );
};

export default InteractionsTab;
